var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aira-label":_vm.arialabel}},[_c('ul',{staticClass:"h-8 md:h-12 flex justify-between items-end sm:justify-start sm:text-base text-primary text-sm"},_vm._l((_vm.menuitems),function(item){return _c('li',{key:item.slug,staticClass:"sm:mr-8 last:mr-0"},[_c('RouterLink',{staticClass:"flex-a h-8 md:h-10 py-1 border-b-5 focus-b",class:[
          `hover:border-${item.palette.primary}`,
          `focus:border-${item.palette.primary}`,
          _vm.active(item)
            ? `border-${item.palette.primary}`
            : 'border-transparent'
        ],attrs:{"to":item.slug},nativeOn:{"click":function($event){return _vm.handleFocus.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.htmlDecode(item.title))+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }